import { Component } from '@angular/core';

@Component({
  selector: 'allas-por-que-elegir-nuestro-servicio',
  imports: [],
  template: `
    <!-- Titulo -->
    <h2
      class="text-xl xl:text-4xl w-full text-center font-bold fs-condensed mt-12 px-4 xl:px-0"
    >
      ¿Por qué elegir nuestro servicio?
    </h2>
    <main
      class="grid grid-cols-1 xl:grid-cols-3 mt-6 max-w-6xl mx-auto w-full gap-8 xl:gap-0 px-4 xl:px-0"
    >
      @for (item of items; track item.title) {
      <article class="flex flex-col gap-4 items-center justify-center">
        <img [src]="item.icon" [alt]="item.title" class="w-auto h-20" />
        <span
          class="text-base xl:text-xl font-bold fs-condensed text-center w-full"
        >
          <span
            [innerHTML]="item.title"
            class="block w-full [&_br]:hidden xl:[&_br]:block"
          ></span>
        </span>
      </article>
      }
    </main>
  `,
})
export class PorQueElegirNuestroServicio {
  items = [
    {
      icon: '/allas-icons/hands-fast-blue.svg',
      title: 'Instalación profesional <br> en minutos',
    },
    {
      icon: '/allas-icons/check-guard.svg',
      title: 'Limpiaparabrisas de <br> calidad garantizada',
    },
    {
      icon: '/allas-icons/parabrisas.svg',
      title: 'Sin riesgo de dañar tu <br> parabrisas',
    },
  ];
}
